import React, { forwardRef } from 'react';

interface ShareFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const ShareFull = forwardRef<HTMLElement, ShareFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-share-from-square ${classes || ''}`} style={style}></i>
  );
});

ShareFull.displayName = 'ShareFull';
